const setRole = (roleUser) => {
    return {
        type: "SET_ROLE",
        payload: roleUser
    }
}

export default {
    setRole
  
}